
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import {IsValid} from '@js/public/mUtils'
export default {
name: 'SLoading',
porps: ['type'],  // type暂时不用，设计之初是定义loading的类型（类型定义参照vux文档的spinner）
components: {
InlineLoading, Spinner
},
data () {
return {
num:1
}
},
created () {
}
}



// WEBPACK FOOTER //
// ./src/components/publicComponents/sLoading.vue